import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {AgentContext} from '../copilot.types';

type BreadcrumbUiContexts = {
  description: string;
  contexts: AgentContext[];
};

const registry = new Map<BreadcrumbName, BreadcrumbUiContexts>();

function registerUiContexts(
  breadcrumbName: BreadcrumbName,
  uiContexts: BreadcrumbUiContexts,
): void {
  registry.set(breadcrumbName, uiContexts);
}

function getUiContextForBreadcrumb(
  breadcrumbName: BreadcrumbName,
): BreadcrumbUiContexts | undefined {
  return registry.get(breadcrumbName);
}

function clearRegistry(): void {
  registry.clear();
}

export {clearRegistry, getUiContextForBreadcrumb, registerUiContexts};
